import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面不存在 - 麻豆视频',
    description: '你访问的页面不存在或已被移动，返回首页继续浏览电影与电视剧内容。',
    keywords: '麻豆视频,页面不存在',
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
        <p className="font-heading text-6xl font-extrabold tracking-tight text-primary-700 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          页面不存在
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
          这个地址可能已经变更，或者链接输入有误。可以返回首页，或从分类页继续查找想看的影视内容。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-300 hover:text-primary-600"
          >
            浏览电影
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}